// extracted by mini-css-extract-plugin
module.exports = {"Body":"bodyWrapper_Body__u_c_w","Left":"bodyWrapper_Left__vGvAV","Right":"bodyWrapper_Right__IBYG7","MainInfo":"bodyWrapper_MainInfo__1YW31"};